import * as ActionTypes from './reports.actionTypes';

export const setReportsSort = (sortingTerm, direction) => (
  dispatch,
  getState
) => {
  return dispatch({
    type: ActionTypes.CHANGE_REPORTS_SORT,
    sortingTerm,
    direction,
  });
};

export const setReportsFilter = (filter, field) => (dispatch, getState) => {
  return dispatch({
    type: ActionTypes.CHANGE_REPORTS_FILTER,
    filter,
    field,
  });
};

export const toggleReportSelectAll = allIds => (dispatch, getState) => {
  return dispatch({
    type: ActionTypes.TOGGLE_REPORT_SELECT_ALL,
    ids: allIds,
  });
};

export const toggleReportSelection = id => (dispatch, getState) => {
  return dispatch({
    type: ActionTypes.TOGGLE_REPORT_SELECTED,
    id,
  });
};

export const setReportsPage = page => (dispatch, getState) => {
  return dispatch({
    type: ActionTypes.CHANGE_REPORTS_PAGE,
    page,
  });
};

export const setReportsPerPage = perPage => (dispatch, getState) => {
  return dispatch({
    type: ActionTypes.CHANGE_REPORTS_PER_PAGE,
    perPage,
  });
};

export const setReportsSearch = search => (dispatch, getState) => {
  return dispatch({
    type: ActionTypes.CHANGE_REPORTS_SEARCH,
    search,
  });
};



// WEBPACK FOOTER //
// ./src/modules/reports/reports.actions.js